import SystemChallenges from './SystemChallenges';

export default SystemChallenges;
